import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/offer-comparison/offer-comparison/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/appInitializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/benefits.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/eeg-data-popup.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/energy-calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/footer-content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/invoice-upload-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/invoice-upload-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/invoice-upload-error-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/mobile-energy-calculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/navigation-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/offer-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/price-comparison.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/promo-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/responsive-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/savings-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/savings-equivalent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/offer-comparison/offer-comparison/src/app/components/sticky-banner.tsx");
